type MetadataValue = string | number | boolean | null | undefined;
type SpanEventAttributes = Record<string, string | number | boolean>;

export type VideoCoverObservabilityMetadata = Record<string, MetadataValue>;

function sanitizeMetadata(metadata?: VideoCoverObservabilityMetadata) {
  return sanitizeObservabilityMetadata(metadata) as SpanEventAttributes;
}

export function logVideoCoverBreadcrumb(
  message: string,
  metadata?: VideoCoverObservabilityMetadata
) {
  void import("@opentelemetry/api")
    .then(({ trace }) => {
      trace.getActiveSpan()?.addEvent(message, sanitizeMetadata(metadata));
    })
    .catch((error) => {
      console.warn(
        "[video-cover-observability] failed to add video-cover breadcrumb (non-fatal)",
        error
      );
    });
}

export async function withVideoCoverSpan<T>(
  name: string,
  metadata: VideoCoverObservabilityMetadata | undefined,
  callback: () => Promise<T>
): Promise<T> {
  const [{ withObservabilitySpan }, { SpanStatusCode }] = await Promise.all([
    import("utils/observability"),
    import("@opentelemetry/api"),
  ]);

  return withObservabilitySpan(
    name,
    sanitizeMetadata(metadata),
    async (span) => {
      const result = await callback();
      span?.setStatus({ code: SpanStatusCode.OK });
      return result;
    }
  );
}
import { sanitizeObservabilityMetadata } from "utils/privacy-safe-observability";
